import { ThemeOptions } from '@material-ui/core/styles/createTheme';

export const northShoppingJoqueiTheme: ThemeOptions = {
  palette: {
    primary: {
      main: '#dec612',
    },
    secondary: {
      main: '#757575',
    },
    /**
     * @todo add tertiary do cliente
     */
    tertiary: {
      main: '#E2E543',
    },
    additionalColors: {
      promoHighligts: '#a79500',
    },
  },
};
